import CompositionHeader from './CompositionHeader'
import ChampionList from '../champion-list/ChampionList'

function PairCard({
  pair,
  imageMap,
  itemComponents,
  itemImageMap,
  copiedCode,
  handleCopy,
}) {
  return (
    <div className="pair-card">
      <CompositionHeader
        tier={pair.tier}
        name={pair.name}
        playStyle={pair.play_style}
        code={pair.planner_code}
        copiedCode={copiedCode}
        handleCopy={handleCopy}
      />
      <ChampionList
        champions={pair.champions}
        imageMap={imageMap}
        itemComponents={itemComponents}
        itemImageMap={itemImageMap}
      />
    </div>
  )
}

export default PairCard
